import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import VariationHandoverContent from '../content/variationHandoverContent';
import addHandoverWrapper from '../handoverWrapper';

class VariationHandover extends React.Component {
	static getTitle(report) {
		return `Variation ${report.variationNo}`;
	}

	render() {
		const report = this.props.report.data[0];
		
		return (
			<VariationHandoverContent report={report} />
		);
	}
}

VariationHandover.propTypes = {
	context: PropTypes.object.isRequired,
	route: PropTypes.object.isRequired,
	report: PropTypes.object.isRequired
};

const mapStateToProps = (state) => ({
	context: state.context
});

export default connect(
	mapStateToProps
)(addHandoverWrapper(
	VariationHandover, {
		title: 'Variation',
		className: 'variation-handover'
	})
);
